import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import imgWallet from '@/assets/icons/wallet.svg';

import styles from './ConnectWallet.module.scss';

type WalletProps = {
  className?: string;
  onClick: VoidFunction;
};

export const ProfileConnectWallet = observer<WalletProps>(
  ({ className, onClick }) => {
    const { t } = useTranslation();

    return (
      <button className={clsx(styles['wallet'], className)} onClick={onClick}>
        <img src={imgWallet} alt="wallet" />
        <div className={styles['wallet__header']}>
          <span>{t('wallet.components.profile.connectWallet')}</span>
        </div>
      </button>
    );
  },
);
